


































































































import DatasourceServices from '@/services/datasource';
import { DataprocessDto } from '@/services/dataprocess';
import { Vue, Component, PropSync, Watch } from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/zh-cn';
@Component
export default class DataprocessFlinksql2 extends Vue {
  @PropSync('formData') syncFormData!: DataprocessDto;
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;

  dsSrv = new DatasourceServices();
  activeKey: string = '0';
  expandIconPosition: string = 'left';
  visibleMore = false;

  dsTypeList = [
      {key: 'MySQL', value: 'MySQL'},
      {key: 'PostgreSQL', value: 'PostgreSQL'},
      {key: 'SQLServer', value: 'SQLServer'},
      {key: 'Oracle', value: 'Oracle'},
      {key: 'elasticsearch', value: 'elasticsearch'},
      {key: 'redis', value: 'redis'}
  ];
  cacheType = ['NONE', 'LRU', 'ALL'];
  dsObjList: any[] = [];

  mounted() {
    this.getDsList();
  }

  async onChangeDsType(e: string, index: number) {
    if (!this.syncFormData.lookupsDsConfig || this.syncFormData.lookupsDsConfig.length <= 0) return ;
    let v = this.syncFormData.lookupsDsConfig[index];
    v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: e });
    this.$forceUpdate();
  }

  async onChangeDs(e: number, index: number) {
    if (!this.syncFormData.lookupsDsConfig || this.syncFormData.lookupsDsConfig.length <= 0) return ;
    let v = this.syncFormData.lookupsDsConfig[index];
    v.lookupDsId = e;
    let datatlookup = v.dsList.filter((v: any) => v.id == e);
    v.lookupDsName = datatlookup && datatlookup.length > 0 ? datatlookup[0].dsName : '';
    if(!v.lookupDsType) { v.lookupDsType = datatlookup[0].dsType; } 
    v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: e });
    this.$forceUpdate();
  }

  async onChangeTable(e: number, index: number) {
    debugger
    if (!this.syncFormData.lookupsDsConfig || this.syncFormData.lookupsDsConfig.length <= 0) return ;
    let v = this.syncFormData.lookupsDsConfig[index];
    v.lookupDsTableId = e;
    let table = v.tableList.filter((v: any) => v.id == e);
    v.lookupDsTableName = table && table.length > 0 ? table[0].tableNameEn : '';
    v.lookupDsColumns = await this.dsSrv.columns({ status_eq: 0, tableId_eq: e });

    this.$forceUpdate();
  }

  @Watch('syncFormData.id')
  async getDsList() {
    
    if (!this.syncFormData.lookupsDsConfig || this.syncFormData.lookupsDsConfig.length <= 0) return ;
    if (this.syncFormData.id) {
      for (let i = 0; i < this.syncFormData.lookupsDsConfig.length; i++) {
          let v = this.syncFormData.lookupsDsConfig[i];
          v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: v.lookupDsType });
          v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: v.lookupDsId });
      }
    } else {
      let ret = await this.dsSrv.getList({ status_eq: 0 });
      this.dsObjList = ret;
      for (let i = 0; i < this.syncFormData.lookupsDsConfig.length; i++) {
          this.syncFormData.lookupsDsConfig[i].dsList = ret;
      }
    }
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  handleClick(index: number) {
    this.syncFormData.lookupsDsConfig && this.syncFormData.lookupsDsConfig.splice(index, 1);
  }

  @Watch('syncFormData.lookupsDsConfig.length')
  onFormDataChange(newVal: number, oldVal: number) {
    debugger
    if(newVal !== oldVal) {
      let index = newVal - 1;
      this.activeKey = '' + index ;
      // this.$nextTick(() => {
      //   this.activeKey = '' + index ;
      // });
    }
  }

  addLookup() {
    if (this.syncFormData.lookupsDsConfig) {
      this.syncFormData.lookupsDsConfig.push({
        lookupDsType: '',
        lookupDsName: '',
        lookupDsTableName: '',
        lookupDsTableLogicName: '',
        lookupDsColumns: [],
        // 主键
        lookupDsPkColumn: '',
        lookupOtherColumns:'',
        // 维表缓存类型(NONE、LRU、ALL)，默认LRU
        cacheType: '',
        // 缓存数据的条数
        cacheMaxRows: 10000,
        // lru维表缓存数据的时间，默认60000毫秒(一分钟)
        cacheTtl: 60000,
        parallelism: 1,
        dsList: this.dsObjList,
        tableList: [],
      });
    }
  }

  removeList(index1: number, index2: number) {
    this.syncFormData.lookupsDsConfig && this.syncFormData.lookupsDsConfig[index1].lookupDsColumns?.splice(index2, 1);
  }

  async confirm() {
    const must: { field: 'lookupDsId' | 'lookupDsType' | 'lookupDsName' | 'lookupDsTableId' | 'lookupDsTableName' ; msessage: string }[] = [
        { field: 'lookupDsId', msessage: '维度数据源不能为空' },
        { field: 'lookupDsType', msessage: '维度数据源类型不能为空' },
        { field: 'lookupDsName', msessage: '维度数据源不能为空' },
        { field: 'lookupDsTableId', msessage: '维度数据对象不能为空' },
        { field: 'lookupDsTableName', msessage: '维度数据对象不能为空' },
    ];
    if (this.syncFormData.lookupsDsConfig && this.syncFormData.lookupsDsConfig.length > 0) {
      for (let i = 0; i < this.syncFormData.lookupsDsConfig.length; i++) {
        let v = this.syncFormData.lookupsDsConfig[i];
        for (let val of must) {
          if (!v[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
      }
    }

    this.syncVisible = false;
    return true;
  }
  
  columns = [{
      title: '字段名',
      dataIndex: 'columnNameEn',
      key: 'columnNameEn',
      width: 70,
      ellipsis: true,
    },
    {
      title: '字段类型',
      dataIndex: 'dataTypeEn',
      key: 'dataTypeEn',
      width: 50,
      ellipsis: true,
    },
    {
      title: '是否主键',
      dataIndex: 'pkFlag',
      key: 'pkFlag',
      width: 30,
      scopedSlots: { customRender: 'pkFlag' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 40,
      scopedSlots: { customRender: 'operation' },
    },
  ];

}
